// Mr. Kics (tema Shopify)
(function(){
  const $=(s)=>document.querySelector(s);
  const dinheiro=(c)=>'$'+(c/100).toFixed(2);
  let cart={items:[],item_count:0,total_price:0};
  function abrir(){ $('#gaveta').classList.add('on'); $('#veu').classList.add('on'); }
  function fechar(){ $('#gaveta').classList.remove('on'); $('#veu').classList.remove('on'); }
  function desenhar(){
    $('#bolha').textContent=cart.item_count; $('#bolha').classList.toggle('on',cart.item_count>0);
    $('#itens').innerHTML = cart.items.length ? cart.items.map(it=>
      '<div class="g-item"><img src="'+(it.image||'')+'" alt=""><div><b>'+it.product_title+'</b><small>'+(it.variant_title||'')+'</small><div class="qtd"><button data-key="'+it.key+'" data-n="'+(it.quantity-1)+'" aria-label="Remove one">−</button><span>'+it.quantity+'</span><button data-key="'+it.key+'" data-n="'+(it.quantity+1)+'" aria-label="Add one">+</button></div></div><div class="vl">'+dinheiro(it.final_line_price)+'</div></div>'
    ).join('') : '<p class="g-vazio">Your cart is empty.</p>';
    $('#subtotal').textContent=dinheiro(cart.total_price);
  }
  async function carregar(){ try{ cart=await (await fetch('/cart.js')).json(); }catch(e){} desenhar(); }
  async function enviar(url,dados){ await fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(dados)}); await carregar(); }
  async function adicionar(id,n){ if(!id) return; await enviar('/cart/add.js',{items:[{id:+id,quantity:n}]}); abrir(); }

  document.querySelectorAll('[data-id]').forEach(b=>b.addEventListener('click',()=>adicionar(b.dataset.id,1)));
  document.querySelectorAll('[data-add]').forEach(b=>b.addEventListener('click',()=>{ const q=parseInt(($('#qtd')||{}).textContent||'1',10)||1; adicionar(b.dataset.add,q); }));
  $('#itens').addEventListener('click',e=>{ const b=e.target.closest('button[data-key]'); if(b) enviar('/cart/change.js',{id:b.dataset.key,quantity:Math.max(0,+b.dataset.n)}); });
  $('#abreCarrinho').addEventListener('click',()=>{ carregar(); abrir(); });
  $('#fechaCarrinho').addEventListener('click',fechar);
  $('#veu').addEventListener('click',fechar);
  document.addEventListener('keydown',e=>{ if(e.key==='Escape') fechar(); });
  $('#menuBt').addEventListener('click',()=>$('#nav').classList.toggle('aberto'));
  document.querySelectorAll('#nav a').forEach(a=>a.addEventListener('click',()=>$('#nav').classList.remove('aberto')));
  carregar();

  // quantidade na pagina de produto
  document.querySelectorAll('[data-q]').forEach(b=>b.addEventListener('click',()=>{
    const s=$('#qtd'); s.textContent=Math.max(1,(parseInt(s.textContent,10)||1)+parseInt(b.dataset.q,10));
  }));

  // galeria da pagina de produto
  document.querySelectorAll('.galeria .mini button').forEach(b=>b.addEventListener('click',()=>{
    document.querySelectorAll('.galeria .mini button').forEach(x=>x.classList.toggle('on',x===b));
    const g=$('.galeria .grande img'); g.src=b.dataset.src; g.alt=b.querySelector('img').alt;
  }));

  // topo: video (vid/hero.mp4 e vid/hero-mobile.mp4; trocar o arquivo = trocar o video) e depois 1 banner por produto, em loop
  (function(){
    const hc=document.getElementById('hc'); if(!hc) return;
    const v=hc.querySelector('.cena-v'), sls=[...hc.querySelectorAll('.sl')], pts=[...hc.querySelectorAll('.pontos button')];
    const BAN=4600; let atual=0, timer=null;
    function mostrar(i){
      clearTimeout(timer); atual=i;
      sls.forEach((el,k)=>el.classList.toggle('on',k===i));
      hc.classList.toggle('claro',i===2);
      pts.forEach((b,k)=>{ b.classList.remove('on','ok'); if(k<i) b.classList.add('ok'); });
      void pts[i].offsetWidth; pts[i].classList.add('on');
      if(i===0 && v){ v.currentTime=0; const p=v.play(); if(p) p.catch(()=>{ clearTimeout(timer); timer=setTimeout(()=>mostrar(1),6000); }); timer=setTimeout(()=>mostrar(1),20000); }
      else { if(v) v.pause(); timer=setTimeout(()=>mostrar((i+1)%sls.length),BAN); }
    }
    if(v){
      const cel=matchMedia('(max-width:640px)').matches;
      v.poster=cel?v.dataset.posterMob:v.dataset.poster; v.src=cel?v.dataset.srcMob:v.dataset.src;
      v.addEventListener('loadedmetadata',()=>pts[0].querySelector('i').style.setProperty('--d',v.duration+'s'));
      v.addEventListener('ended',()=>{ if(atual===0) mostrar(1); });
    }
    pts.forEach((b,k)=>b.addEventListener('click',()=>mostrar(k)));
    mostrar(0);
  })();

  // carrossel de reviews: video do centro toca sozinho (previa sem som); clique = review completo com som
  (function(){
    const c=document.getElementById('rvc'); if(!c) return;
    const its=[...c.querySelectorAll('.rvc-item')], n=its.length; let a=0, som=false, ligado=false;
    function classes(){ its.forEach((el,i)=>{ const d=(i-a+n)%n; el.className='rvc-item'+(d===0?' ativo':d===1?' dir':d===n-1?' esq':''); }); }
    function pos(){
      classes();
      its.forEach((el,i)=>{ const v=el.querySelector('video');
        if(i===a){ if(!ligado) return; if(v.dataset.cur!=='prev'){ v.src=v.dataset.prev; v.dataset.cur='prev'; } v.muted=true; v.loop=true; v.controls=false; v.play().catch(()=>{}); }
        else { v.pause(); if(v.dataset.cur==='full'){ v.src=v.dataset.prev; v.dataset.cur='prev'; v.controls=false; } }
      });
    }
    function ir(k){ som=false; a=(k+n)%n; pos(); }
    c.querySelector('.rvc-seta.e').addEventListener('click',()=>ir(a-1));
    c.querySelector('.rvc-seta.d').addEventListener('click',()=>ir(a+1));
    its.forEach((el,i)=>el.addEventListener('click',()=>{
      if(i!==a){ ir(i); return; }
      if(!som){ som=true; const v=el.querySelector('video'); v.src=v.dataset.full; v.dataset.cur='full'; v.muted=false; v.loop=false; v.controls=true; v.play().catch(()=>{}); el.classList.add('som'); }
    }));
    let x0=null;
    c.addEventListener('touchstart',e=>{ x0=e.touches[0].clientX; },{passive:true});
    c.addEventListener('touchend',e=>{ if(x0===null) return; const dx=e.changedTouches[0].clientX-x0; if(Math.abs(dx)>40) ir(dx<0?a+1:a-1); x0=null; },{passive:true});
    classes();
    const io=new IntersectionObserver(es=>{ if(es[0].isIntersecting){ ligado=true; pos(); io.disconnect(); } },{threshold:.25});
    io.observe(c);
  })();

  // revelar ao rolar
  const io=new IntersectionObserver(es=>es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }),{threshold:.12});
  document.querySelectorAll('.rv').forEach((el,i)=>{ el.style.transitionDelay=(i%3)*.08+'s'; io.observe(el); });
})();
